// @flow
import * as React from 'react';
import { Box } from '@locus-taxy/neo-ui';

import 'react-loading-skeleton/dist/skeleton.css';

import ReactSkeleton from 'react-loading-skeleton';

type Props = {
    count?: number,
    height?: number,
    borderRadius?: number
};

const Wrapper = ({ children }) => {
    return <Box m={1}>{children}</Box>;
};

const Skeleton = ({ count = 0, height, borderRadius }: Props): React.Node => {
    return (
        <ReactSkeleton
            wrapper={Wrapper}
            count={count}
            height={height}
            borderRadius={borderRadius}
        />
    );
};

export default Skeleton;
